import { BifrostBackendNestApi } from "../../gateways/BifrostBackendApi";
import appConfig from "../../appconfig";

const SubscriberDetailsProvider = {
	async getDetails(idpToken) {
		const idpManagementQueryParams = {
			tenantId: appConfig.tenantConfig.tenantId
		};
		return BifrostBackendNestApi.get(`/subscriptions/details`, {
			params: idpManagementQueryParams,
			headers: {
				Authorizationidp: idpToken
			}
		})
			.then(({ data }) => data);
	}
};

export default Object.freeze(SubscriberDetailsProvider);
